import { format } from 'date-fns';

/** @returns {object|null} null = skip HTTP call (empty result). */
function baseParams(committedDateRange) {
	const params = { skip: 0, limit: 1000 };
	if (committedDateRange?.from) {
		params.startDate = format(committedDateRange.from, 'yyyy-MM-dd');
	}
	if (committedDateRange?.to) {
		params.endDate = format(committedDateRange.to, 'yyyy-MM-dd');
	}
	return params;
}

function categoryIdsForSide(committedNames, sideCategories) {
	const names = (committedNames || []).filter(n => n && n !== 'All');
	if (names.length === 0) return null;
	const ids = [];
	for (const name of names) {
		const c = sideCategories.find(x => x.name === name);
		if (c?.id) ids.push(String(c.id));
	}
	return ids;
}

/**
 * @param incomeCategories
 * @param committedCategoryNames
 * @param committedDateRange
 * @param {"All"|"Income"|"Expense"} committedType
 * @returns {object|null} null = do not call incomes API
 */
export function buildTransactionsIncomeParams(
	incomeCategories,
	committedCategoryNames,
	committedDateRange,
	committedType,
) {
	if (committedType === 'Expense') return null;
	const names = (committedCategoryNames || []).filter(n => n && n !== 'All');
	const ids = categoryIdsForSide(committedCategoryNames, incomeCategories);
	if (names.length > 0 && (!ids || ids.length === 0)) return null;
	const params = baseParams(committedDateRange);
	if (ids?.length) params.categoryIds = ids;
	return params;
}

/**
 * @returns {object|null} null = do not call expenses API
 */
export function buildTransactionsExpenseParams(
	expenseCategories,
	committedCategoryNames,
	committedDateRange,
	committedType,
) {
	if (committedType === 'Income') return null;
	const names = (committedCategoryNames || []).filter(n => n && n !== 'All');
	const ids = categoryIdsForSide(committedCategoryNames, expenseCategories);
	if (names.length > 0 && (!ids || ids.length === 0)) return null;
	const params = { offset: 0, limit: 1000 };
	if (committedDateRange?.from) {
		params.startDate = format(committedDateRange.from, 'yyyy-MM-dd');
	}
	if (committedDateRange?.to) {
		params.endDate = format(committedDateRange.to, 'yyyy-MM-dd');
	}
	if (ids?.length) params.categoryIds = ids;
	return params;
}
